export default "__VITE_ASSET__50cb90af__"